import { FormCodeEditorProps } from '../../code/FormCodeEditor';
import { FormCodeEditor } from '@/components/form/form';

export type FormSqlWhereInputProps = FormCodeEditorProps;

export const FormSqlWhereInput = ({
  name,
  placeholder = "A SQL WHERE expression, e.g.\ncolumn_name IN ('val1', 'val2', 'val3') AND col2 IS NOT NULL",
  ...props
}: FormSqlWhereInputProps) => {
  return (
    <FormCodeEditor
      name={name}
      placeholder={placeholder}
      className="min-h-[70px]"
      {...props}
    />
  );
};
